import React, { useEffect, useState } from 'react';
import translations from '../../translation'; // Importing translations file

const RecentActivity = ({ language }) => {
  const [activities, setActivities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const translate = (key) => translations[language]?.[key] || key;

  useEffect(() => {
    fetchRecentActivities();
  }, []);

  const fetchRecentActivities = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_CHECK_USER_API}/api/admin/activity`, {
        method: 'GET',
      });

      const data = await response.json();
      if (data.success) {
        setActivities(data.data || []);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error('Error fetching recent activities:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="bg-white shadow rounded-lg overflow-hidden mt-5">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg leading-6 font-medium text-gray-900">
          {translate('recentActivityTitle')}
        </h3>
      </div>
      {isLoading ? (
        <div className="text-center py-6 text-gray-600">{translate('loadingText')}</div>
      ) : activities.length === 0 ? (
        <div className="text-center py-6 text-gray-600">{translate('noRecentActivity')}</div>
      ) : (
        <div className="border-t border-gray-200">
          <div className="flow-root">
            <ul className="divide-y divide-gray-200">
              {activities.map((activity, index) => (
                <li key={index} className="p-4 hover:bg-gray-50 transition-colors">
                  <div className="flex items-center space-x-4">
                    {/* Status Icon */}
                    <div>
                      <span
                        className={`h-10 w-10 rounded-full flex items-center justify-center ${
                          activity.status === 'Approved'
                            ? 'bg-green-100'
                            : activity.status === 'Rejected'
                            ? 'bg-red-100'
                            : 'bg-yellow-100'
                        }`}
                      >
                        <i
                          className={`fas ${
                            activity.status === 'Approved'
                              ? 'fa-check text-green-600'
                              : activity.status === 'Rejected'
                              ? 'fa-times text-red-600'
                              : 'fa-clock text-yellow-600'
                          }`}
                        />
                      </span>
                    </div>
                    {/* Activity Details */}
                    <div className="flex-1 flex flex-col space-y-1">
                      <p className="text-sm font-semibold text-gray-700">
                        {activity.status === 'Approved' && (
                          <span className="text-green-600">
                            {translate('approvedStatus')}
                          </span>
                        )}
                        {activity.status === 'Rejected' && (
                          <span className="text-red-600">
                            {translate('rejectedStatus')}
                          </span>
                        )}
                        {activity.status === 'Pending' && (
                          <span className="text-yellow-600">
                            {translate('pendingStatus')}
                          </span>
                        )}
                      </p>
                      <p className="text-sm text-gray-900">
                        {translate('announcementTitled')}{' '}
                        <span className="font-medium">{activity.title}</span>{' '}
                        {translate('createdBy')}{' '}
                        <span className="font-medium text-gray-700">
                          {activity.sender_name || translate('unknownUser')}
                        </span>
                        {activity.status !== 'Pending' && (
                          <>
                            {' '}
                            {translate('and')}{' '}
                            {activity.status.toLowerCase()}{' '}
                            {translate('by')}{' '}
                            <span className="font-medium text-gray-700">
                              {activity.approved_by_name || translate('unknownUser')}
                            </span>.
                          </>
                        )}
                      </p>
                    </div>
                    {/* Activity Timestamp */}
                    <div className="text-sm text-gray-500 whitespace-nowrap ml-4">
                      <time dateTime={new Date(activity.date).toISOString()}>
                        {new Date(activity.date).toLocaleString([], {
                          hour: '2-digit',
                          minute: '2-digit',
                          day: '2-digit',
                          month: 'short',
                          year: 'numeric',
                        })}
                      </time>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecentActivity;
